import axios from "../../axios";
import {
  PRODUCT_ADD_SUCCESS,
  PRODUCT_ADD_REQUEST,
  PRODUCT_ADD_FAIL,
  //
  PRODUCT_LIST_SUCCESS,
  PRODUCT_LIST_REQUEST,
  PRODUCT_LIST_FAIL,
  //
  PRODUCT_DETAIL_SUCCESS,
  PRODUCT_DETAIL_REQUEST,
  PRODUCT_DETAIL_FAIL,
  //
  PRODUCT_DELETE_SUCCESS,
  PRODUCT_DELETE_REQUEST,
  PRODUCT_DELETE_FAIL,
  //
  PRODUCT_UPDATE_SUCCESS,
  PRODUCT_UPDATE_REQUEST,
  PRODUCT_UPDATE_FAIL,
  //
  PRODUCT_EXTRA_LIST_SUCCESS,
  PRODUCT_EXTRA_LIST_REQUEST,
  PRODUCT_EXTRA_LIST_FAIL,
  //
  PRODUCT_EXTRA_DELETE_SUCCESS,
  PRODUCT_EXTRA_DELETE_REQUEST,
  PRODUCT_EXTRA_DELETE_FAIL,
  PRODUCT_EXTRA_DELETE_RESET,
  //
  PRODUCT_EXTRA_ADD_SUCCESS,
  PRODUCT_EXTRA_ADD_REQUEST,
  PRODUCT_EXTRA_ADD_FAIL,
  PRODUCT_EXTRA_ADD_RESET,
  //
  PRODUCT_EXTRA_ADD_ITEM_SUCCESS,
  PRODUCT_EXTRA_ADD_ITEM_REQUEST,
  PRODUCT_EXTRA_ADD_ITEM_FAIL,
  PRODUCT_EXTRA_ADD_ITEM_RESET,
  //
  PRODUCT_EXTRA_DELETE_ITEM_SUCCESS,
  PRODUCT_EXTRA_DELETE_ITEM_REQUEST,
  PRODUCT_EXTRA_DELETE_ITEM_FAIL,
  PRODUCT_EXTRA_DELETE_ITEM_RESET,
  //
} from "../constants/productConstants";

// create extra item
export const addNewExtraItem = (id, item) => async (dispatch, getState) => {
  try {
    dispatch({
      type: PRODUCT_EXTRA_ADD_ITEM_REQUEST,
    });
    var {
      userLogin: { userInfo },
    } = getState();
    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${userInfo.access}`,
      },
    };
    const { data } = await axios.post(
      `/extras/create-item/${id}/`,
      item,
      config
    );

    dispatch({
      type: PRODUCT_EXTRA_ADD_ITEM_SUCCESS,
      payload: data,
    });
  } catch (error) {
    var err =
      error.response && error.response.data.detail
        ? error.response.data.detail
        : error.detail;
    if (err) {
      if (
        err === "Given token not valid for any token type" ||
        err === "User not found"
      ) {
        localStorage.removeItem("userInfoExpressHalalAdmin");
        document.location.href = "/";
      }
    }
    dispatch({
      type: PRODUCT_EXTRA_ADD_ITEM_FAIL,
      payload:
        error.response && error.response.data.detail
          ? error.response.data.detail
          : "This user has not been added, please try again.",
    });
  }
};

// create extra
export const addNewExtra = (id, extra) => async (dispatch, getState) => {
  try {
    dispatch({
      type: PRODUCT_EXTRA_ADD_REQUEST,
    });
    var {
      userLogin: { userInfo },
    } = getState();
    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${userInfo.access}`,
      },
    };
    const { data } = await axios.post(`/extras/create/${id}/`, extra, config);

    dispatch({
      type: PRODUCT_EXTRA_ADD_SUCCESS,
      payload: data,
    });
  } catch (error) {
    var err =
      error.response && error.response.data.detail
        ? error.response.data.detail
        : error.detail;
    if (err) {
      if (
        err === "Given token not valid for any token type" ||
        err === "User not found"
      ) {
        localStorage.removeItem("userInfoExpressHalalAdmin");
        document.location.href = "/";
      }
    }
    dispatch({
      type: PRODUCT_EXTRA_ADD_FAIL,
      payload:
        error.response && error.response.data.detail
          ? error.response.data.detail
          : "This user has not been added, please try again.",
    });
  }
};

// delete extra
export const deleteExtra = (id) => async (dispatch, getState) => {
  try {
    dispatch({
      type: PRODUCT_EXTRA_DELETE_REQUEST,
    });
    var {
      userLogin: { userInfo },
    } = getState();
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.access}`,
      },
    };
    const { data } = await axios.delete(`/extras/delete/${id}/`, config);

    dispatch({
      type: PRODUCT_EXTRA_DELETE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    var err =
      error.response && error.response.data.detail
        ? error.response.data.detail
        : error.detail;
    if (err) {
      if (
        err === "Given token not valid for any token type" ||
        err === "User not found"
      ) {
        localStorage.removeItem("userInfoExpressHalalAdmin");
        document.location.href = "/";
      }
    }
    dispatch({
      type: PRODUCT_EXTRA_DELETE_FAIL,
      payload:
        error.response && error.response.data.detail
          ? error.response.data.detail
          : "Votre profile n'a pas été modifié, réessayez",
    });
  }
};

// delete extra item
export const deleteExtraItem = (id) => async (dispatch, getState) => {
  try {
    dispatch({
      type: PRODUCT_EXTRA_DELETE_ITEM_REQUEST,
    });
    var {
      userLogin: { userInfo },
    } = getState();
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.access}`,
      },
    };
    const { data } = await axios.delete(`/extras/delete-item/${id}/`, config);

    dispatch({
      type: PRODUCT_EXTRA_DELETE_ITEM_SUCCESS,
      payload: data,
    });
  } catch (error) {
    var err =
      error.response && error.response.data.detail
        ? error.response.data.detail
        : error.detail;
    if (err) {
      if (
        err === "Given token not valid for any token type" ||
        err === "User not found"
      ) {
        localStorage.removeItem("userInfoExpressHalalAdmin");
        document.location.href = "/";
      }
    }
    dispatch({
      type: PRODUCT_EXTRA_DELETE_ITEM_FAIL,
      payload:
        error.response && error.response.data.detail
          ? error.response.data.detail
          : "Failed to delete the item. Please try again.",
    });
  }
};

// reset delete extra item state
export const resetDeleteExtraItem = () => (dispatch) => {
  dispatch({ type: PRODUCT_EXTRA_DELETE_ITEM_RESET });
};

// reset delete extra state
export const resetDeleteExtra = () => (dispatch) => {
  dispatch({ type: PRODUCT_EXTRA_DELETE_RESET });
};

// reset add extra state
export const resetAddExtra = () => (dispatch) => {
  dispatch({ type: PRODUCT_EXTRA_ADD_RESET });
};

// reset add extra item state
export const resetAddExtraItem = () => (dispatch) => {
  dispatch({ type: PRODUCT_EXTRA_ADD_ITEM_RESET });
};

// get list products
export const getListExtraProduct =
  (page, product) => async (dispatch, getState) => {
    try {
      dispatch({
        type: PRODUCT_EXTRA_LIST_REQUEST,
      });
      var {
        userLogin: { userInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo.access}`,
        },
      };
      const { data } = await axios.get(
        `/extras/product/${product}?page=${page}`,
        config
      );

      dispatch({
        type: PRODUCT_EXTRA_LIST_SUCCESS,
        payload: data,
      });
    } catch (error) {
      var err =
        error.response && error.response.data.detail
          ? error.response.data.detail
          : error.detail;
      if (err) {
        if (
          err === "Given token not valid for any token type" ||
          err === "User not found"
        ) {
          localStorage.removeItem("userInfoExpressHalalAdmin");
          document.location.href = "/";
        }
      }
      dispatch({
        type: PRODUCT_EXTRA_LIST_FAIL,
        payload:
          error.response && error.response.data.detail
            ? error.response.data.detail
            : error.detail,
      });
    }
  };

// delete product
export const deleteProduct = (id) => async (dispatch, getState) => {
  try {
    dispatch({
      type: PRODUCT_DELETE_REQUEST,
    });
    var {
      userLogin: { userInfo },
    } = getState();
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.access}`,
      },
    };
    const { data } = await axios.delete(`/products/delete/${id}/`, config);

    dispatch({
      type: PRODUCT_DELETE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    var err =
      error.response && error.response.data.detail
        ? error.response.data.detail
        : error.detail;
    if (err) {
      if (
        err === "Given token not valid for any token type" ||
        err === "User not found"
      ) {
        localStorage.removeItem("userInfoExpressHalalAdmin");
        document.location.href = "/";
      }
    }
    dispatch({
      type: PRODUCT_DELETE_FAIL,
      payload:
        error.response && error.response.data.detail
          ? error.response.data.detail
          : "Votre profile n'a pas été modifié, réessayez",
    });
  }
};

// create product
export const updateProduct = (id, product) => async (dispatch, getState) => {
  try {
    dispatch({
      type: PRODUCT_UPDATE_REQUEST,
    });
    var {
      userLogin: { userInfo },
    } = getState();
    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${userInfo.access}`,
      },
    };
    const { data } = await axios.put(
      `/products/update/${id}/`,
      product,
      config
    );

    dispatch({
      type: PRODUCT_UPDATE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    var err =
      error.response && error.response.data.detail
        ? error.response.data.detail
        : error.detail;
    if (err) {
      if (
        err === "Given token not valid for any token type" ||
        err === "User not found"
      ) {
        localStorage.removeItem("userInfoExpressHalalAdmin");
        document.location.href = "/";
      }
    }
    dispatch({
      type: PRODUCT_UPDATE_FAIL,
      payload:
        error.response && error.response.data.detail
          ? error.response.data.detail
          : "This user has not been added, please try again.",
    });
  }
};

// get product detail
export const getProductDetail = (id) => async (dispatch, getState) => {
  try {
    dispatch({
      type: PRODUCT_DETAIL_REQUEST,
    });
    var {
      userLogin: { userInfo },
    } = getState();
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.access}`,
      },
    };
    const { data } = await axios.get(`/products/detail/${id}/`, config);

    dispatch({
      type: PRODUCT_DETAIL_SUCCESS,
      payload: data,
    });
  } catch (error) {
    var err =
      error.response && error.response.data.detail
        ? error.response.data.detail
        : error.detail;
    if (err) {
      if (err === "Given token not valid for any token type") {
        localStorage.removeItem("userInfoUnimedCare");
        document.location.href = "/";
      }
    }
    dispatch({
      type: PRODUCT_DETAIL_FAIL,
      payload:
        error.response && error.response.data.detail
          ? error.response.data.detail
          : error.detail,
    });
  }
};

// create product
export const addNewProduct = (product) => async (dispatch, getState) => {
  try {
    dispatch({
      type: PRODUCT_ADD_REQUEST,
    });
    var {
      userLogin: { userInfo },
    } = getState();
    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${userInfo.access}`,
      },
    };
    const { data } = await axios.post(`/products/create/`, product, config);

    dispatch({
      type: PRODUCT_ADD_SUCCESS,
      payload: data,
    });
  } catch (error) {
    var err =
      error.response && error.response.data.detail
        ? error.response.data.detail
        : error.detail;
    if (err) {
      if (
        err === "Given token not valid for any token type" ||
        err === "User not found"
      ) {
        localStorage.removeItem("userInfoExpressHalalAdmin");
        document.location.href = "/";
      }
    }
    dispatch({
      type: PRODUCT_ADD_FAIL,
      payload:
        error.response && error.response.data.detail
          ? error.response.data.detail
          : "This user has not been added, please try again.",
    });
  }
};

// get list products
export const getListProducts = (page) => async (dispatch, getState) => {
  try {
    dispatch({
      type: PRODUCT_LIST_REQUEST,
    });
    var {
      userLogin: { userInfo },
    } = getState();
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.access}`,
      },
    };
    const { data } = await axios.get(`/products/admin/?page=${page}`, config);

    dispatch({
      type: PRODUCT_LIST_SUCCESS,
      payload: data,
    });
  } catch (error) {
    var err =
      error.response && error.response.data.detail
        ? error.response.data.detail
        : error.detail;
    if (err) {
      if (
        err === "Given token not valid for any token type" ||
        err === "User not found"
      ) {
        localStorage.removeItem("userInfoExpressHalalAdmin");
        document.location.href = "/";
      }
    }
    dispatch({
      type: PRODUCT_LIST_FAIL,
      payload:
        error.response && error.response.data.detail
          ? error.response.data.detail
          : error.detail,
    });
  }
};
